import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import type { ICustomSelectValue, IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';
import { isCompleteHouse } from '@sravni/cosago-react-library/lib/validationSchemes';
import { useCallback } from 'react';

import { useGetFullAddressAutocomplete } from 'shared/api/daData/dadata.query';
import type { TFullData } from 'shared/types/TUserAddressFields';

import { CommonAddressField } from '../CommonAddressField/CommonAddressField';

export const OneFieldRegistrationAddress = (props: IFieldFactoryProps) => {
  const { type } = props;

  const handleOnHide = (newValue: Nullable<ICustomSelectValue>) =>
    isCompleteHouse(Number(newValue?.data?.fias_level), String(newValue?.value));
  const { getValues, setValue } = useFormContext();
  const [getAddressAutocomplete] = useGetFullAddressAutocomplete();

  const onInitialSuggestsLoad = useCallback(
    (option: Dictionaries.TSelectOption<string, TFullData>) => {
      setValue(type, option);
    },
    [setValue, type],
  );

  const getFullAddress = useCallback(
    async (search: string) => {
      const response = await getAddressAutocomplete({ search }, true);
      if (response.isError) {
        return [];
      }
      return response.data || [];
    },
    [getAddressAutocomplete],
  );

  return (
    <CommonAddressField
      {...props}
      getAddress={getFullAddress}
      handleOnHide={handleOnHide}
      initialValue={getValues(type)}
      onInitialSuggestsLoad={onInitialSuggestsLoad}
    />
  );
};
